import styles from '../../maintenancerequestdetails.module.css';
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { X } from "react-feather";
import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import { useAuth0 } from "@auth0/auth0-react";
import { AddLogCallAPI } from '../../../../components/AddLogs';
import { useForm } from 'react-hook-form';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SummaryTab = ({ requestData, setRequestData, setSnackbarOpen, setSnackbarMsg, setLoading }) => {
    const { user, isAuthenticated } = useAuth0();
    const { getAccessTokenSilently } = useAuth0();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [deleteType, setDeleteType] = useState(0);
    const [requestImage, setRequestImage] = useState('/static/img/other.svg');
    const [oldData, setOldData] = useState({ description: '', resolution: '' });
    const [newData, setNewData] = useState({ description: '', resolution: '' });
    const [charsLeft, setCharsLeft] = useState({ description: 200, resolution: 200 });
    const [isUpdate, setIsUpdate] = useState(false);
    const [isUpdate2, setIsUpdate2] = useState(false);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(1);
    const [lightboxOpen2, setLightboxOpen2] = useState(false);
    const [lightboxIndex2, setLightboxIndex2] = useState(1);
    const [carouselImages, setCarouselImages] = useState([]);
    const [carouselImages2, setCarouselImages2] = useState([]);

    const { handleSubmit, register, setValue } = useForm();
    const [taskExpanded, setTaskExpanded] = useState("panel1");

    useEffect(() => {
        if (requestData) {
            if (requestData?.sub_category === 'Electrical Socket') {
                setRequestImage("/static/img/ElectricalSocket.svg");
            } else if (requestData?.sub_category === 'Light Switch/Dimmer') {
                setRequestImage("/static/img/Dimmer.svg");
            } else if (requestData?.sub_category === 'Mount Television') {
                setRequestImage("/static/img/tv.svg");
            } else if (requestData?.sub_category === 'Leak') {
                setRequestImage("/static/img/Leak.svg");
            } else if (requestData?.sub_category === 'Drain Clogged') {
                setRequestImage("/static/img/DrainClogged.svg");
            } else if (requestData?.sub_category === 'Water Temperature Issue') {
                setRequestImage("/static/img/WaterTemperature.svg");
            } else if (requestData?.sub_category === 'Heating & Cooling System') {
                setRequestImage("/static/img/heat&cool.svg");
            } else if (requestData?.sub_category === 'Stove/Oven Issue') {
                setRequestImage("/static/img/StoveOven.svg");
            } else if (requestData?.sub_category === 'Refrigerator Issue') {
                setRequestImage("/static/img/Refrigerator.svg");
            } else if (requestData?.sub_category === 'Washer/Dryer Issue') {
                setRequestImage("/static/img/Washer.svg");
            } else if (requestData?.sub_category === 'Other Issue') {
                setRequestImage("/static/img/other.svg");
            }

            setOldData({ description: requestData?.description, resolution: requestData?.resolution ? requestData?.resolution : '' });
            setNewData({ description: requestData?.description, resolution: requestData?.resolution ? requestData?.resolution : '' });

            setValue('description', requestData?.description);
            setValue('resolution', requestData?.resolution);

            if (requestData?.description?.length) {
                setCharsLeft(prev => {
                    return { ...prev, description: 200 - requestData?.description?.length };
                })
            }
            if (requestData?.resolution?.length) {
                setCharsLeft(prev => {
                    return { ...prev, resolution: 200 - requestData?.resolution?.length };
                })
            }

            let reqImages = requestData?.images?.map(i => {
                if (i?.file_path.split('.').pop() === 'jpeg' || i?.file_path.split('.').pop() === 'jpg' || i?.file_path.split('.').pop() === 'png' || i?.file_path.split('.').pop() === 'svg') {
                    return i;
                }
                return null;
            });

            reqImages = reqImages?.filter(i => i !== null);

            setCarouselImages(reqImages);

            let reqImages2 = requestData?.resolve_images?.map(i => {
                if (i?.file_path.split('.').pop() === 'jpeg' || i?.file_path.split('.').pop() === 'jpg' || i?.file_path.split('.').pop() === 'png' || i?.file_path.split('.').pop() === 'svg') {
                    return i;
                }
                return null;
            });

            reqImages2 = reqImages2?.filter(i => i !== null);

            setCarouselImages2(reqImages2);
        }
    }, [requestData, setValue]);

    useEffect(() => {
        if (oldData) {
            if (oldData?.description === newData?.description) {
                setIsUpdate(false);
            } else {
                setIsUpdate(true);
            }
        }
    }, [newData, oldData]);

    useEffect(() => {
        if (oldData) {
            if (oldData?.resolution === newData?.resolution) {
                setIsUpdate2(false);
            } else {
                setIsUpdate2(true);
            }
        }
    }, [newData, oldData]);

    const deleteConfirm = async () => {
        setLoading(true);
        setOpenDeleteModal(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/' + deleteId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setRequestData(prev => {
                if (deleteType === 1) {
                    let images = prev?.resolve_images?.filter(i => i?.id !== deleteId);
                    return { ...prev, resolve_images: images };
                } else {
                    let images = prev?.images?.filter(i => i?.id !== deleteId);
                    return { ...prev, images: images };
                }
            });

            let logData = {
                'title': 'Maintenance request image deleted',
                'description': [
                    'Name: ' + requestData?.title,
                    'Request number: ' + requestData?.request_no,
                    'Property: ' + requestData?.property_name,
                    'Apartment: ' + requestData?.apt_name,
                    'Tenant: ' + requestData?.tenant_name,
                ]
            }
            AddLogCallAPI(logData, token);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const fileHandler = async (e) => {
        let extErr = false;
        let sizeErr = false;
        let files = e.target.files;
        let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

        if (files.length > 0) {
            if (allowedExtensionArr.length > 0) {
                let fileName = files[0].name;
                let fileSize = files[0].size;
                let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
                fileNameExt = '.' + fileNameExt;

                if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
                    extErr = true;
                }

                if (fileSize >= 5242880) {
                    sizeErr = true;
                }
            }
        }

        if (extErr) {
            toast.error("File type is not allowed.");
            return false;
        }

        if (sizeErr) {
            toast.error("File size should not be greater than 5 MB.");
            return false;
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        setLoading(true);

        let formData = new FormData();
        formData.append("image", files[0]);

        axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/upload', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg('Files uploaded successfully.');

            setRequestData(prev => {
                let images = response.data.data.concat(prev?.images);
                return { ...prev, images: images };
            });

            let logData = {
                'title': 'Maintenance request image uploaded',
                'description': [
                    'Name: ' + requestData?.title,
                    'Request number: ' + requestData?.request_no,
                    'Property: ' + requestData?.property_name,
                    'Apartment: ' + requestData?.apt_name,
                    'Tenant: ' + requestData?.tenant_name,
                ]
            }
            AddLogCallAPI(logData, token);

        }).catch(error => {
            setLoading(false);
        });
    }

    const fileHandler2 = async (e) => {
        let extErr = false;
        let sizeErr = false;
        let files = e.target.files;
        let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

        if (files.length > 0) {
            if (allowedExtensionArr.length > 0) {
                let fileName = files[0].name;
                let fileSize = files[0].size;
                let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
                fileNameExt = '.' + fileNameExt;

                if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
                    extErr = true;
                }

                if (fileSize >= 5242880) {
                    sizeErr = true;
                }
            }
        }

        if (extErr) {
            toast.error("File type is not allowed.");
            return false;
        }

        if (sizeErr) {
            toast.error("File size should not be greater than 5 MB.");
            return false;
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        setLoading(true);

        let formData = new FormData();
        formData.append("image", files[0]);

        axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/resolve-files/upload', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg('Files uploaded successfully.');

            setRequestData(prev => {
                let images = response.data.data.concat(prev?.resolve_images);
                return { ...prev, resolve_images: images };
            });

            let logData = {
                'title': 'Maintenance request resolution image uploaded',
                'description': [
                    'Name: ' + requestData?.title,
                    'Request number: ' + requestData?.request_no,
                    'Property: ' + requestData?.property_name,
                    'Apartment: ' + requestData?.apt_name,
                    'Tenant: ' + requestData?.tenant_name,
                ]
            }
            AddLogCallAPI(logData, token);

        }).catch(error => {
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setRequestData(prev => {
                return { ...prev, description: response.data.data?.description, resolution: response.data.data?.resolution };
            });

            let logData = {
                title: "Maintenance request is updated",
                description: [
                    "Name: " + response.data.data.title,
                    "Request number: " + response.data.data.request_no,
                    "Property: " + response.data.data.property_name,
                    "Apartment: " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate2 = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-new/" + requestData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setRequestData(prev => {
                return { ...prev, description: response.data.data?.description, resolution: response.data.data?.resolution };
            });

            let logData = {
                title: "Maintenance request is updated",
                description: [
                    "Name: " + response.data.data.title,
                    "Request number: " + response.data.data.request_no,
                    "Property: " + response.data.data.property_name,
                    "Apartment: " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const handleChange7 = (panel) => (event, isTaskExpanded) => {
        setTaskExpanded(isTaskExpanded ? panel : false);
    };

    return (<>
        <button className={`${styles.SummeryTitle}`}>
            <img src={requestImage} alt="" />
            {requestData?.title}
        </button>

        <div className="FormAccording ProspectTask Theme">
            <Accordion expanded={taskExpanded === "panel1"} onChange={handleChange7("panel1")}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <div className={`${styles.FormAccoHead}`}>
                        <p className={`${styles.FormAccoHeadTitle}`}>Request</p>
                    </div>
                </AccordionSummary>
                <AccordionDetails className={`${styles.CussAccoRow}`}>
                    <form onSubmit={handleSubmit(onUpdate)}>
                        <div className={`${styles.SummFormFull}`}>
                            <p className={`${styles.SummFormLabel}`}>Maintenance Issue Description</p>
                            <textarea name="description" ref={register} className={`${styles.formControlTextArea}`} maxLength={200} onChange={(e) => {
                                setCharsLeft(prev => {
                                    return { ...prev, description: 200 - e.target.value?.length };
                                });

                                setNewData(prev => {
                                    return { ...prev, description: e.target.value };
                                });
                            }} disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1)}></textarea>
                            <p className={`${styles.RemainingText}`}>{charsLeft?.description} {charsLeft?.description > 1 ? "characters" : "character"} remaining</p>
                        </div>
                        {isUpdate && <div>
                            <button type='submit' className={`${styles.SummaryUpdateBU}`}>Update</button>
                        </div>}
                    </form>
                    <div className={`${styles.BorderDivSumm}`}>
                        <p className={`${styles.SummFormLabel}`}>Request Photos</p>

                        <div className={`${styles.Row}`}>
                            {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <div className={`${styles.FileUpDuBUDiv}`}>
                                <label for="file-upload" className={`${styles.UploadLabel}`}>
                                    <span>
                                        <div className={`${styles.UpIcon}`}>
                                            <img src="/static/img/uploadIMG.svg" alt="" />
                                        </div>{" "}
                                        Upload Documents/Photos
                                    </span>
                                    <p className={`${styles.UploadText}`}>
                                        File size upto 10 MB. <br /> JPG, PNG, PDF, DOC, XLS file only
                                    </p>
                                </label>
                                <input id="file-upload" type="file" onChange={fileHandler} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                            </div>}
                            {requestData?.images?.map((item, index) => {
                                return (<div className={`${styles.SummFormSemiHalf}`}>
                                    {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request:update") > -1) && <button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(0); }}><X /></button>}
                                    {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                        <img src="/static/img/docIcon.png" />
                                        <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                    </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                        <img src="/static/img/excelIcon.png" />
                                        <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                    </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                        <img src="/static/img/pdfIcon.png" />
                                        <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                    </a> : <img src={item?.file_public_url} className={styles.UpIMG} alt="" onClick={(e) => { setLightboxOpen(true); setLightboxIndex(index); }} />)))}
                                </div>)
                            })}
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>

            {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-resolve:show")) > -1 && <Accordion expanded={taskExpanded === "panel2"} onChange={handleChange7("panel2")}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <div className={`${styles.FormAccoHead}`}>
                        <p className={`${styles.FormAccoHeadTitle}`}>Resolution</p>
                    </div>
                </AccordionSummary>
                <AccordionDetails className={`${styles.CussAccoRow}`}>
                    <form onSubmit={handleSubmit(onUpdate2)}>
                        <div className={`${styles.SummFormFull}`}>
                            <p className={`${styles.SummFormLabel}`}>Resolution</p>
                            <textarea name="resolution" ref={register} className={`${styles.formControlTextArea}`} maxLength={200} onChange={(e) => {
                                setCharsLeft(prev => {
                                    return { ...prev, resolution: 200 - e.target.value?.length };
                                });

                                setNewData(prev => {
                                    return { ...prev, resolution: e.target.value };
                                });
                            }}></textarea>
                            <p className={`${styles.RemainingText}`}>{charsLeft?.resolution} {charsLeft?.resolution > 1 ? "characters" : "character"} remaining</p>
                        </div>
                        {isUpdate2 && <div>
                            <button type='submit' className={`${styles.SummaryUpdateBU}`}>Update</button>
                        </div>}
                    </form>
                    <div className={`${styles.BorderDivSumm}`}>
                        <p className={`${styles.SummFormLabel}`}>Resolution Photos</p>

                        <div className={`${styles.Row}`}>
                            <div className={`${styles.FileUpDuBUDiv}`}>
                                <label for="file-upload2" className={`${styles.UploadLabel}`}>
                                    <span>
                                        <div className={`${styles.UpIcon}`}>
                                            <img src="/static/img/uploadIMG.svg" alt="" />
                                        </div>{" "}
                                        Upload Documents/Photos
                                    </span>
                                    <p className={`${styles.UploadText}`}>
                                        File size upto 10 MB. <br /> JPG, PNG, PDF, DOC, XLS file only
                                    </p>
                                </label>
                                <input id="file-upload2" type="file" onChange={fileHandler2} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                            </div>
                            {requestData?.resolve_images?.map((item, index) => {
                                return (<div className={`${styles.SummFormSemiHalf}`}>
                                    <button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(1); }}><X /></button>
                                    {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                        <img src="/static/img/docIcon.png" />
                                        <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                    </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                        <img src="/static/img/excelIcon.png" />
                                        <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                    </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                                        <img src="/static/img/pdfIcon.png" />
                                        <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                                    </a> : <img src={item?.file_public_url} alt="" onClick={(e) => { setLightboxOpen2(true); setLightboxIndex2(index); }} />)))}

                                </div>)
                            })}
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>}
        </div>

        <Dialog
            open={openDeleteModal}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setOpenDeleteModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">Are you sure you want to delete the image?<button onClick={(e) => setOpenDeleteModal(false)}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The image will be removed immediately.You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</Button>
                <Button className="SubmitPopupBU" onClick={(e) => setOpenDeleteModal(false)}>Cancel</Button>
            </DialogActions>
        </Dialog>

        <Lightbox
            open={lightboxOpen}
            close={() => setLightboxOpen(false)}
            index={lightboxIndex}
            carousel={{ finite: true, preload: 2, padding: "16px", spacing: "30%", imageFit: "contain" }}
            slides={carouselImages?.map(i => {
                if (i?.file_path.split('.').pop() === 'jpeg' || i?.file_path.split('.').pop() === 'jpg' || i?.file_path.split('.').pop() === 'png' || i?.file_path.split('.').pop() === 'svg') {
                    return { src: i?.file_public_url };
                }
                return null;
            })}
        />

        <Lightbox
            open={lightboxOpen2}
            close={() => setLightboxOpen2(false)}
            index={lightboxIndex2}
            carousel={{ finite: true, preload: 2, padding: "16px", spacing: "30%", imageFit: "contain" }}
            slides={carouselImages2?.map(i => {
                return { src: i?.file_public_url };
            })}
        />
    </>);
}

export default SummaryTab;